import {LiveReducer, ReducerFromState} from "../../../@types/reducers";

export const getTemplate = (state: ReducerFromState<LiveReducer>): null | string => state.live.template;
